import { render, staticRenderFns } from "./HistoryTabs.vue?vue&type=template&id=56bfa3d4"
import script from "./HistoryTabs.vue?vue&type=script&lang=js"
export * from "./HistoryTabs.vue?vue&type=script&lang=js"
import style0 from "./HistoryTabs.vue?vue&type=style&index=0&id=56bfa3d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports